import React, {Component} from 'react';
import styled from 'styled-components'

import {withRouter} from "react-router";
import {Box, Card, Flex, Heading} from 'rebass';
import {Content, MobileHeader} from "../../components/Base";
import {maxHeight} from "styled-system";

import {sortBy} from 'lodash-es'
import ChatCard from '../../components/Cards/ChatCard'
import {AddButton} from "../../components/Base/Buttons";
import Messages from '../../components/Chat/Messages'
import InputToolbar from '../../components/Chat/InputToolbar'
import ChatMembers from './ChatMembers'


const Wrapper = styled(Flex)`
max-height: calc(100vh - 174px);
//height: 100%;
`;

const InputWrapper = styled(Box)`
	position: fixed;
	background-color: transparent;
	bottom: 0;
	right: 0;
	width: calc(100vw - 350px)
`

const SidebarWrapper = styled(Card)`
	${maxHeight}
	//max-width: 350px
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  //@media(min-width: 700px ){
  //height: calc(100vh-174px);
  //}
`;

SidebarWrapper.defaultProps = {
	maxHeight: ['calc(100vh - 174px)'],
	pb: [3, 0]
};


class Chat extends Component {

	state = {
		openChat: false,
		createdChats: [],
		joinedChats: [],
		messages: [],
		members: [],
		memberIds: [],
		// selected: {name: '', uid: '', message: '', isRead: false},
		selected: {
			id: 1,
			creator_uid: '1234',
			accepted: {status: 3, updated_at: null},
			message: '',
			name: '',
			members: []
		}
	};

	componentDidMount() {
		// const {profile} = this.props;
		const {currentChat} = this.props;
		if(currentChat !== null){
			this.currentListener = this.fetchSelectedChatListener(currentChat)
		}
		// this.createdListener = this.fetchCreatedListener()
		this.joinedListener = this.fetchJoinedListener()
		// this.listener = this.props.firebase.chats().
	}

	handleKeyPress = (event) => {
		if (event.key !== 'Enter') return;
		this.sendMessage();
	};

	fetchJoinedListener = () => {
		const {profile} = this.props;
		return this.props.firebase.chats().where('members', 'array-contains', profile.id).onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));

			this.setState({joinedChats: result})
		})
	};


	handleChatSelect = (item) => {
		const {width, history, updateChatId} = this.props;
		updateChatId(item.id)
		if (width < 500) {
			history.push(`/app/chat/${item.id}`)
		} else {
			this.updateAsRead(item)
			// this.currentListener = this.fetchSelectedChatListener(item.id)
		}
	};

	componentWillReceiveProps(nextProps, nextContext) {
		if(nextProps.currentChat !== this.props.currentChat){ 
			if(nextProps.currentChat === 1){
				this.setState({selected: {
						id: 1,
						creator_uid: '1234',
						accepted: {status: 3, updated_at: null},
						message: '',
						name: '',
						members: []
					}})
			} else {
				this.currentListener = this.fetchSelectedChatListener(nextProps.currentChat)
			}

		}
	}

	fetchSelectedChatListener = (id) => {
		this.props.firebase.chat(id).onSnapshot(snapshot => {
			const result = {id: snapshot.id, ...snapshot.data()};
			this.updateAsRead(result)
			this.fetchUserDetails(result);
		})
	}

	fetchUserDetails = async (item) => {
		const {profile} = this.props;
		let ids = [];
		let members = [];
		if(item.members) {
			if (item.members.includes(item.creator_uid)) {
				ids = item.members
			} else {
				ids = [item.creator_uid, ...item.members]

			}


			let count = 1;
			// id map for formatting messages with id 0 - logged in user
			let idMap = {};
			for (let i in ids) {
				if (ids[i] === profile.id) {
					idMap[ids[i]] = {id: 0, senderName: 'You'}
				} else {
					idMap[ids[i]] = {id: count, senderName: ''};
					count++;
				}
			}
			if(item.creator_uid.length !== 4 && item.is_group && item.creator_uid !== profile.id && !item.accepted.members.includes(profile.id)){
				// console.log(!item.accepted.members.includes(profile.id))
				item.messages = []
			}
			// try {

			for (let i in ids) {
				if (ids[i] !== profile.id) {
					if (ids[i].length === 7) {
						let student = await this.props.firebase.student(ids[i]).get();
						let data = {id: student.id, ...student.data()}
						members.push(data);
						idMap[data.id].senderName = data.first_name
						idMap[data.id].profileImage = data.profile_pic
					} else {
						let faculty = await this.props.firebase.faculty(ids[i]).get();
						let data = {id: faculty.id, ...faculty.data()}
						members.push(data);
						idMap[data.id].senderName = data.first_name
						idMap[data.id].profileImage = data.profile_pic
					}
				}
			} 
 

			let messages = [];
			for (let x = 0; x < item.messages.length; x++) {
				let user = idMap[item.messages[x].uid];
				if (user) {
					let message = item.messages[x]

					messages.push({
						id: user.id,
						message: item.messages[x].message,
						senderName: user.senderName,
						postTime: item.messages[x].created_at,
						profile_pic: user.profileImage,
						has_attachment: message.has_attachment === true,
						attachment: message.attachment,
						type: message.attachment_type,
						file_name: message.file_name
					})
				}
			}
			// console.log('members', members)
			// item.members = members;
			// console.log(members)
			this.setState({selected: item, current: item.id, messages: messages, members, idMap: idMap, memberIds: ids})

			// } catch (error) {
			// 	console.log(error)
			// }
		}
	};

	updateAsRead = (item) => {
		const {profile} = this.props;
		let messages = item.messages;
		let isUpdated = false;
		for (let i in messages) {
			if (!messages[i].seen.includes(profile.id)) {
				messages[i].seen.push(profile.id);
				isUpdated = true;
			}
		}

		try {
			if(isUpdated) {
				let chatRef = this.props.firebase.chats().doc(item.id);
				chatRef.update({messages: messages})
			}
		} catch (error) {
			//console.log(error)
		}
	};



	joinAndSortChats = () => {
		const {createdChats, joinedChats} = this.state;
		let allChats = [...createdChats, ...joinedChats];
		let sortedChats = sortBy(allChats, [(item => item.last_updated)], 'desc');
		sortedChats = sortedChats.reverse();
		return sortedChats
	};

	handleInput = (e) => {
		this.setState({message: e.target.value})
	};

	sendMessage = async () => {
		const {selected, message} = this.state;
		const {profile, firebase} = this.props;
		let msg = message;
		if (msg !== '') {
			try {
				this.setState({message: ''})
				let chatRef = firebase.chat(selected.id);

				await chatRef.update({
					last_updated: Math.floor(Date.now() / 1000),
					messages: firebase.fieldValue.arrayUnion({
							uid: profile.id,
							message: msg,
							seen: [profile.id],
							created_at: Math.floor(Date.now() / 1000)
						}
					)
				});
				//console.log(newMessageResult);
			} catch (error) {
				//console.log(error)
			}
		}
	};

	componentWillUnmount() {
		// this.createdListener()
		this.joinedListener()
		this.currentListener && this.currentListener()
	}


	render() {
		const { selected, messages, members, memberIds} = this.state;
		const {width, profile, isFaculty, currentChat} = this.props;
		const chats = this.joinAndSortChats();

		const nameList = members.filter(member => member.id !== profile.id).map((member, i) => i > 0 ? (member.first_name + ' ' + member.last_name) : (member.first_name + ' ' + member.last_name));
		let chatTitle = nameList.join('')
		if(selected.is_group){
			if(selected.name !== ''){
				chatTitle = selected.name
			} else {
				chatTitle = `Group Chat (${selected.members.length - 1})`
			}
		} else {
			const nameList =members.filter(member => member.id !== profile.id).map((member, i) => i > 0 ? (member.first_name + ' ' + member.last_name) : (member.first_name + ' ' + member.last_name));
			chatTitle = nameList.join(', ');
		}

		return (
			<Box>

				<MobileHeader>
					<Heading py={2}>Chats</Heading>
				</MobileHeader>

				<Content pt={[0,2]} pb={[0,1]}>
					<Box pt={[0,'12px']} pl={[0, 4]} pb={[0,3]}>

						<AddButton to={'/app/chat/new'}/>
					</Box>

					<Wrapper>

						{/* Sidebar Chat List START */}
						<Box width={[1, 1, '350px']}>
							<SidebarWrapper boxShadow={['none', 'main']}>

								{chats.map(item => {
									let isDeleted = item.deleted;
									if (!isDeleted || !(isDeleted && (isDeleted.length > 0) && isDeleted.includes(profile.id))) {
										return <ChatCard key={item.id} item={item} handleClick={this.handleChatSelect}
											profile={profile} />
									} 
									return null;
								})}
							</SidebarWrapper>
						</Box>

						{/* Sidebar Chat list END*/}


						{/* Main chat window only on Desktop START*/}
						{width > 500 && selected.id !== 1 && currentChat !== 1 &&

						<Flex flexDirection={'column'} width={1} justifyContent={'space-between'} alignItems={'stretch'}
						      flexWrap={'wrap'}>
							<Card boxShadow={'inset'} p={2}>
								<ChatMembers title={chatTitle} members={members} profile={profile} chat={selected} defaultSelected={memberIds}/>

							</Card>
							{/*<ChatContainer css={{height: '60vh'}}>*/}
							<Box pb={'40px'}>
							<Messages messages={messages} profile={profile} chat={selected} height={'calc(100vh - 297px'}/>
							{/*</ChatContainer>*/}
							</Box>
 
							<InputWrapper>
								<InputToolbar
									selected={selected}
									profile={profile}
									isFaculty={isFaculty}
									members={members}
								/>
							</InputWrapper>
						</Flex>

						}

						{/*	 Main Chat window END*/}
					</Wrapper>
				</Content>
			</Box>
		)
	}
}


export default withRouter(Chat)
